import { GLOBAL_LOADING_INCREMENT, GLOBAL_LOADING_DECREMENT } from '../../actions/GlobalLoading/consts'

const initialState = {
  requestCount: 0
}

export default function GlobalLoadingReducer(state = initialState, action) {
  switch (action.type) {
  case GLOBAL_LOADING_INCREMENT:
    return { ...state, requestCount: state.requestCount + 1 }
  case GLOBAL_LOADING_DECREMENT:
    return { ...state, requestCount: Math.max(0, state.requestCount - 1) }
  default:
    return state
  }
}
